import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { TournamentService } from '../../services/tournament.service';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../model/permission-enum';
import { Tournament } from '../../model/tournament';

@Component({
  selector: 'app-tournaments-list',
  standalone: true,
  imports: [CommonModule, RouterModule, LucideAngularModule],
  templateUrl: './tournaments-list.component.html',
  styleUrl: './tournaments-list.component.css',
})
export class TournamentsListComponent implements OnInit {
  tournaments: Tournament[] = [];
  loading = true;
  isAdmin = false;

  constructor(
    private tournamentService: TournamentService,
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.auth.waitForInitialization();
    const perms = this.auth.currentUserPermissions ?? [];
    // JWT `permission` claim is serialized as a string ("2"); use loose
    // equality to match it against the numeric enum, as the rest of the app does.
    this.isAdmin = perms.some((p: PermissionEnum) => p == PermissionEnum.Admin);

    this.tournamentService.list({ upcomingOnly: true }).subscribe({
      next: rows => { this.tournaments = rows; this.loading = false; },
      error: () => { this.tournaments = []; this.loading = false; },
    });
  }

  goToCreate(): void {
    this.router.navigate(['/admin/tournaments/new']);
  }

  goToDetail(id: number): void {
    this.router.navigate(['/tournaments', id]);
  }
}
